module.exports = __webpack_public_path__ + "fa-brands-400.woff2?ed311c7a0ade9a75bb3ebf5a7670f31d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/webfonts/fa-brands-400.woff2
// module id = 1448
// module chunks = 0